const PageActions = () => {
  // when clicking page-actions__top, smooth scroll to top of page
  const pageActionsTop = document.querySelector(".page-actions__top");

  if (pageActionsTop) {
    pageActionsTop.addEventListener("click", (e) => {
      e.preventDefault();

      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    });
  }
};

export default PageActions;
